import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { postData } from '../Services/api'
import { toast } from 'react-toastify'

const AddUser = () => {
    const [values, setValues] = useState({
        fullName: "",
        email: "",
        mobile: "",
        gender: "",
        dob: "",
        password: "",
        role: 'user',
        profileImage: null,
    })

    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split("T")[0];
    const navigate = useNavigate();

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValues(prev => ({
                ...prev,
                profileImage: file,
            }));
        }
    };

    const validateUser = () => {
        const { fullName, email, mobile, gender, dob, password } = values;

        if (!fullName.trim()) {
            toast.dismiss();
            toast.error("Full name is required.");
            return false;
        }
        if (!email.trim()) {
            toast.dismiss();
            toast.error("Email is required.");
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            toast.dismiss();
            toast.error("Invalid email format.");
            return false;
        }
        if (!mobile.trim()) {
            toast.dismiss();
            toast.error("Mobile number is required.");
            return false;
        }
        if (mobile.length < 10) {
            toast.dismiss();
            toast.error("Mobile number must be at least 10 digits.");
            return false;
        }
        if (!/^\d{10}$/.test(mobile)) {
            toast.dismiss();
            toast.error("Mobile number must be exactly 10 digits.");
            return false;
        }
        if (!gender.trim()) {
            toast.dismiss();
            toast.error("Gender is required.");
            return false;
        }
        if (!dob.trim()) {
            toast.dismiss();
            toast.error("Date of birth is required.");
            return false;
        }
        if (!password.trim()) {
            toast.dismiss();
            toast.error("Password is required.");
            return false;
        }
        if (password.length < 6) {
            toast.dismiss();
            toast.error("Password must be at least 6 characters.");
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateUser()) return;
        setLoading(true)
        try {
            const formData = new FormData();
            formData.append('fullName', values.fullName);
            formData.append('email', values.email);
            formData.append('mobile', values.mobile);
            formData.append('gender', values.gender);
            formData.append('dob', values.dob);
            formData.append('password', values.password);
            formData.append('role', values.role);
            if (values.profileImage) {
                formData.append('profileImage', values.profileImage);
            }
            const res = await postData('/users/create', formData);
            if (res.status) {
                toast.success(res.message)
                navigate('/users/user-list');
                setValues({
                    fullName: "",
                    email: "",
                    mobile: "",
                    gender: "",
                    dob: "",
                    password: "",
                    profileImage: null,
                })
            }
        } catch (error) {
            console.log("error user adding",)
            toast.error(error.data.response.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/users/user-list">
                                                Users</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add User
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Add User</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add User</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-12 text-center mb-3">
                                                <div className="user-upload wid-75">
                                                    <img
                                                        src={values.profileImage ? URL.createObjectURL(values.profileImage) : avtar5}
                                                        alt="img"
                                                        className="img-fluid"
                                                    />
                                                    <label htmlFor="uplfile" className="img-avtar-upload">
                                                        <i className="fa fa-camera f-24 mb-1" />
                                                        <span>Upload</span>
                                                    </label>
                                                    <input type="file" id="uplfile" className="d-none" onChange={handleImageChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        name='fullName'
                                                        value={values.fullName}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter Email Address"
                                                        name='email'
                                                        value={values.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Gender</label>
                                                    <select className="form-select"
                                                        name='gender'
                                                        value={values.gender}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select gender</option>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                        <option value="other">Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Mobile Number</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Mobile Number"
                                                        name='mobile'
                                                        value={values.mobile}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Dob.</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter dob"
                                                        name='dob'
                                                        value={values.dob}
                                                        onChange={handleChange}
                                                        max={today}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Password</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter password"
                                                        name='password'
                                                        value={values.password}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/users/user-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddUser